import { ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

const prohibitedActions = [
  "Creating, selling, or offering unauthorized menu items.",
  "Changing recipes, ingredients, portions, or food preparation standards.",
  "Offering personal discounts, complimentary meals, refunds, or promotions.",
  "Changing prices or making unauthorized POS adjustments.",
  "Giving away restaurant food, supplies, or inventory.",
  "Accepting payments outside approved company payment systems.",
  "Removing company inventory or equipment without authorization.",
  "Ignoring food safety, sanitation, or allergen-handling procedures.",
  "Misusing customer information, company accounts, or restaurant systems.",
  "Violating applicable military installation security or supermarket operating requirements.",
];

export function EmploymentPolicies() {
  return (
    <section
      className="mb-8 flex flex-wrap items-center justify-between gap-4 border-y border-neutral-200 py-5"
      data-testid="employment-policies-link"
    >
      <div>
        <p className="font-medium text-neutral-900">Review Employment Policies & Expectations</p>
        <p className="mt-1 text-sm text-neutral-500">
          Applicants should review our workplace standards before applying.
        </p>
      </div>
      <Link
        to="/employment-policies"
        className="inline-flex items-center gap-2 text-sm font-semibold text-[hsl(var(--primary))]"
        data-testid="careers-employment-policies-link"
      >
        Read policies
        <ArrowRight className="h-4 w-4" />
      </Link>
    </section>
  );
}

export function EmploymentPoliciesFull() {
  return (
    <section
      className="mb-10 border-y border-neutral-200 py-9"
      data-testid="employment-policies"
    >
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-neutral-950 text-white">
          <ShieldCheck className="h-5 w-5" />
        </div>
        <div>
          <p className="eyebrow mb-2">Sandar Sushi LLC</p>
          <h2 className="font-display text-3xl font-bold tracking-tight">
            Employment Policies & Expectations
          </h2>
        </div>
      </div>

      <div className="mt-6 space-y-5 text-sm leading-relaxed text-neutral-700">
        <p>
          At Sandar Sushi LLC, we are committed to maintaining high standards of food quality,
          customer service, cleanliness, professionalism, and operational consistency across all
          our locations.
        </p>
        <p>
          All employees are expected to follow company policies, approved recipes, established
          menus, pricing structures, food safety procedures, and management instructions.
        </p>
        <div>
          <h3 className="font-display text-xl font-bold tracking-tight">
            Strictly Prohibited Without Company Authorization
          </h3>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            {prohibitedActions.map((action) => <li key={action}>{action}</li>)}
          </ul>
        </div>
        <p>
          Employees must maintain professionalism, report to work reliably, follow assigned duties,
          and respect customers, coworkers, and management.
        </p>
        <div>
          <h3 className="font-display text-xl font-bold tracking-tight">Policy Violations</h3>
          <p className="mt-3">
            Failure to follow company policies may result in corrective action, including written
            warnings, suspension where lawful, or termination of employment, depending on the
            circumstances and applicable law.
          </p>
          <p className="mt-3">
            Serious misconduct, including theft, fraud, intentional food tampering, or major safety
            violations, may result in immediate disciplinary action up to termination.
          </p>
        </div>
        <p>
          All employees must acknowledge the complete Sandar Sushi Employee Handbook and Location
          Operating Standards before beginning their duties.
        </p>
        <p>
          Sandar Sushi LLC is an equal opportunity employer and complies with applicable employment
          laws.
        </p>
      </div>
    </section>
  );
}